import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGlobalContext } from '~/context/GlobalContext';
import classNames from 'classnames';
import { IRoomProps } from '~/types/common';
import { UsersIcon } from '~/components/Icons/Icons';
import styles from '~/componentsPage/HomePage/styles/FantasiesRoom.module.css';

const FantasiesRoom = ({ data, goToChat }: IRoomProps) => {
  const { context, setContext } = useGlobalContext();
  const navigate = useNavigate();

  return (
    <div data-component="FantasiesRoom" className={styles.fantasiesRoom}>
      <div
        className={styles.roomButton}
        key={data.id}
        onClick={() => goToChat(data.id)}
      >
        <div className={styles.title}>
          {data.name}
        </div>
        <div className={styles.count}>
          <UsersIcon className={styles.usersIcon}/> 
          <div>{data.usersCount ? data.usersCount : '0'}</div>
        </div>
      </div>
    </div>
  );
};

export default FantasiesRoom;
